import { CIcon } from '~/icons/types'

export const ciJobs: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M8.99 9.973H7.622c.11 1.096.5 2.147 1.134 3.049a6.115 6.115 0 0 0 3.82 2.5v-1.875A3.634 3.634 0 0 0 8.99 9.973Zm3.586 5.552h.005l-.005-.002v.002Zm9.867 3.906-.009-.01-.009-.009-3.132-4.184-.4-.533-.506.423a6.525 6.525 0 0 1-.713.523l-.574.36.375.57 2.878 4.366v.01l.01.01a1.26 1.26 0 0 0 1.78.287 1.331 1.331 0 0 0 .3-1.813Z'
    },
    {
      d:
        'M17.348 14.45a6.415 6.415 0 0 0 1.4-8.807 6.09 6.09 0 0 0-5-2.623 6.006 6.006 0 0 0-3 .807c.268.579.403 1.21.394 1.849A4.317 4.317 0 0 1 9.712 8.9a4.777 4.777 0 0 1 3.966 4.745v2a6 6 0 0 0 3.67-1.196ZM7.617 8.764a3.151 3.151 0 0 0 2.428-3.093c0-.407-.076-.811-.225-1.19a6.326 6.326 0 0 0-2.152 3.837c-.018.15-.037.298-.051.446Zm-1.106.042a8.26 8.26 0 0 1 .08-.668 7.422 7.422 0 0 1 2.634-4.615A3.042 3.042 0 0 0 6.956 2.5a3.136 3.136 0 0 0-3.094 3.17 3.146 3.146 0 0 0 2.649 3.136Zm1.345 4.874a7.569 7.569 0 0 1-1.34-3.711h-1.6a3.634 3.634 0 0 0-3.587 3.674v7a.844.844 0 0 0 .835.855h9.581a.842.842 0 0 0 .834-.855v-3.97a7.184 7.184 0 0 1-4.723-2.992Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'jobs',
  type: 'solid'
}
